import { Injectable } from '@angular/core';
import { BackendService } from 'app/core/backend.service';
import { CONFIG } from 'app/core/config';
import { HbNotification } from 'app/notifications/notification';
import { NotificationState } from 'app/notifications/notification-state';
import { NotificationService } from 'app/notifications/notification.service';
import { OrgTreeNodeErpIdentifier } from 'app/viewmodels/analysis/org-tree-node-erp-identifier';
import { RunnableModelOrgTreeNodeType } from 'app/viewmodels/media/media';
import { Observable, ReplaySubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RecommendationsService {
  public readonly orgTreeNodeChanged: ReplaySubject<string> = new ReplaySubject<string>(1);
  activateInspectionPlan = new Subject();
  public orgTreeNodeId: string;

  constructor(private backendService: BackendService, private notificationService: NotificationService) { }


  public showNotification(description: string, state: NotificationState) {
    const notification = new HbNotification();
    notification.description = description;
    notification.state = state;
    this.notificationService.displayToast(notification);
  }

  public getErpIdentifier(orgTreeNodeId: string): Observable<OrgTreeNodeErpIdentifier> {
    return this.backendService.getById<OrgTreeNodeErpIdentifier>(OrgTreeNodeErpIdentifier, orgTreeNodeId);
  }

  public getModelOrgTreeLinkHasMedia(runnableModelOrgTreeNodeId: string): Observable<boolean> {
    return this.backendService.getBooleanResponse(
      `${CONFIG.apiRoutes.modelOrgLinksMediaFlag}/${runnableModelOrgTreeNodeId}/${RunnableModelOrgTreeNodeType.Mitigations.toString()}`,
    );
  }

  public resetLocalData(): void {
    this.orgTreeNodeId = null;
  }
}
